export const Phone1 = '0121 433 3333';
export const Phone2 = '0121 788 8888';
export const Phone3 = '01527 222222';
export const Phone4 = '01676 222 222';

export const TimeZone = 'Europe/London';
